import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import Avatar from '~/components/Avatar'

const CustomerMediaList = ({ item }) => {
  return (
    <div>
      <div className="d-flex justify-content-center">
        <Avatar
          size="lg"
          className="mr-2"
          img={item.attribution?.profilePhotoUrl}
        />
        <div>
          <h6>
            <FormattedMessage id="Sent by" />:
          </h6>
          <h5>{item.attribution.profileName}</h5>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        {item.mediaFormat === 'PHOTO' ? (
          <Image src={item.googleUrl} />
        ) : (
          <a href={item.googleUrl}>Ver no google</a>
        )}
      </div>
    </div>
  )
}

const Image = styled.img`
  max-height: 500px;
  object-fit: contain;
  margin-bottom: 10px;
`

export default CustomerMediaList
